export const DEPLOYMENT_STEP = "DEPLOYMENT_STEP";
export const PERMISSION_STEP = "PERMISSION_STEP";
export const CONNECTION_STEP = "CONNECTION_STEP";
export const CONFIGURATION_STEP = "CONFIGURATION_STEP";
